import React, { useEffect } from "react";
import { createPortal } from "react-dom";

import "./Modal.css";

/**
 * Centered overlay dialog. Rendered via portal to `document.body` so it is not clipped
 * or positioned inside scrollable ancestors (e.g. data tables).
 */
const Modal = ({ open, title, children, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  const content = (
    <div className="fixed inset-0 z-[10050] flex items-center justify-center overflow-y-auto bg-black/40 p-3 sm:p-4">
      <div
        className="relative my-auto w-full max-w-[95vw] sm:max-w-[90vw] md:max-w-[800px] lg:max-w-[1000px] max-h-[min(90vh,920px)] overflow-y-auto rounded-lg bg-white p-1 shadow-xl sm:p-4 md:p-5"
        role="dialog"
        aria-modal="true"
        aria-labelledby="app-modal-title"
      >
        <div className="mb-1 flex items-center justify-between border-b border-gray-200 pb-1">
          <h2 id="app-modal-title" className="m-0 text-sm font-semibold sm:text-base md:text-lg">
            {title}
          </h2>
          <button
            type="button"
            onClick={() => onClose?.()}
            className="rounded-md p-1 text-gray-500 transition hover:bg-gray-100 hover:text-red-600"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default Modal;
